import { render } from "./PhoneQuotaReachedNotice.vue?vue&type=template&id=bfc9658a&ts=true"
import script from "./PhoneQuotaReachedNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneQuotaReachedNotice.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/whatsapp-meta/components/PhoneQuotaReachedNotice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bfc9658a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bfc9658a', __exports__)) {
    api.reload('bfc9658a', __exports__)
  }
  
  module.hot.accept("./PhoneQuotaReachedNotice.vue?vue&type=template&id=bfc9658a&ts=true", () => {
    api.rerender('bfc9658a', render)
  })

}


export default __exports__